<template>
    <div>
        <div v-for="relatedProduct in relatedProducts">
            <div v-if="relatedProduct.products.length > 0">
                <h2 class="section-title">
                    <span>{{ relatedProduct.name }}</span>
                </h2>

                <vueper-slides
                    ref="cartRelatedProductVslides"
                    class="no-shadow mx-25px"
                    :class="{ 'cant-slide': !relatedProduct.canSlide }"
                    fixed-height="360px"
                    :visible-slides="5"
                    slide-multiple
                    :gap="1"
                    :slide-ratio="1 / 4"
                    :dragging-distance="200"
                    :breakpoints="{
                        550: { visibleSlides: 2, slideMultiple: 2 },
                        800: { visibleSlides: 3, slideMultiple: 3 },
                        1200: { visibleSlides: 4, slideMultiple: 4 },
                        1500: { visibleSlides: 5, slideMultiple: 5 }
                    }"
                    :bullets="false"
                    :arrows="true"
                    style="margin: 26px;"
                >
                    <vueper-slide v-for="product in relatedProduct.products"
                                  :key="product.id"
                                  :title="product.name"
                                  style="height: 100%;"
                    >
                        <template #content>
                            <div>
                                <div class="listitem">
                                    <article class="article product-item">
                                        <a :href="product.url" :title="product.name">
                                            <div class="article-media article-media-2-by-3 my-position-relative">
                                                <div class="product-image-2-by-3 my-position-relative">
                                                    <badges :product="product" />
                                                    <responsive-image
                                                        v-if="product.coverImage"
                                                        :media="product.coverImage"
                                                        :alt="product.name"
                                                        classes="product-image"
                                                        style="margin-bottom: auto; margin-top: auto;"
                                                    />
                                                </div>
                                            </div>

                                            <div class="article-header text-center">
                                                <h3 class="article-title">{{ product.name }}</h3>

                                                <div class="article-price">
                                                    <div :class="{promo: product.isDiscounted }">
                                                    <span>
                                                        {{ product.price | currency(currencyFormat(product.currency)) }}
                                                    </span>
                                                        <del v-if="product.isDiscounted">
                                                            {{ product.originalPrice | currency(currencyFormat(product.currency)) }}
                                                        </del>
                                                    </div>
                                                </div>
                                            </div>
                                        </a>
                                    </article>
                                </div>
                            </div>
                        </template>
                    </vueper-slide>
                </vueper-slides>
            </div>
        </div>
    </div>
</template>

<script>
import { VueperSlides, VueperSlide } from 'vueperslides'
import 'vueperslides/dist/vueperslides.css'
import Badges from '../../products/partials/Badges';
import ResponsiveImage from '../../mediaLibrary/ResponsiveImage';
import currencyFormatter from "../../mixins/currencyFormatter";

export default {
    name: 'CartRelatedProduct',
    mixins: [currencyFormatter],
    components: {
        VueperSlides,
        VueperSlide,
        Badges,
        ResponsiveImage,
    },

    data() {
        return {
            relatedProducts: [],
        }
    },

    created() {
        this.fetchRelatedProducts();
    },

    updated() {
        for (let i = 0; i < this.relatedProducts.length; i++) {
            this.relatedProducts[i].canSlide = this.$refs.cartRelatedProductVslides[i].canSlide
        }
    },

    methods: {
        async fetchRelatedProducts() {
            await axios.get('/api/cart-related-products')
                .then((response) => {
                    if (response.data) {
                        this.relatedProducts = response.data.relatedProducts
                    }
                })
                .catch((error) => {

                })
        }
    }
}
</script>

<style lang="scss">
.cant-slide {
    .vueperslides__track-inner {
        justify-content: center;
    }
}
</style>
